<form class="pre-form" #formulari="ngForm">
  <mat-grid-list cols="4" rows="3" rowHeight="80px">            
      <mat-grid-tile>
          <mat-form-field class="pre-field">
              <mat-select name="tipus-document-identificatiu" placeholder="Tipus document" 
                [formControl]="tipusDocumentIdentificatiuInput" [(ngModel)]="preinscripcio.alumne.tipusDocument" i18n-placeholder>
                  <mat-option *ngFor="let td of tipusDocuments" [value]="td.value">
                      {{ td.name }}
                  </mat-option>
              </mat-select>
              <mat-error i18n>
                    El document identificatiu no és vàlid!
              </mat-error>              
          </mat-form-field>  
      </mat-grid-tile>      
      <mat-grid-tile>
          <mat-form-field class="pre-field">
              <input type="text" name="document-identificatiu" matInput placeholder="Document identificatiu" disabled 
                [(ngModel)]="preinscripcio.alumne.documentIdentificatiu" i18n-placeholder>
          </mat-form-field>  
      </mat-grid-tile>                                                                                                                  
      <mat-grid-tile>
          <mat-form-field class="pre-field">
              <mat-select name="sexe" placeholder="Sexe" [(ngModel)]="preinscripcio.alumne.sexe" i18n-placeholder>
                  <mat-option *ngFor="let td of sexes" [value]="td.value">
                      {{ td.name }}
                  </mat-option>
              </mat-select>
          </mat-form-field>  
      </mat-grid-tile>
      <mat-grid-tile></mat-grid-tile>                                
      <mat-grid-tile>
              <mat-form-field class="pre-field">
                  <input type="text" name="nom" matInput placeholder="Nom" required [(ngModel)]="preinscripcio.alumne.nom" [disabled]="!preinscripcio.alumne.isnew" i18n-placeholder>
              </mat-form-field>  
      </mat-grid-tile>
      <mat-grid-tile>
              <mat-form-field class="pre-field">
                  <input type="text" name="cognom1" matInput placeholder="Primer cognom" required [(ngModel)]="preinscripcio.alumne.cognom1" [disabled]="!preinscripcio.alumne.isnew" i18n-placeholder>
              </mat-form-field>  
      </mat-grid-tile>
      <mat-grid-tile>
          <mat-form-field class="pre-field">
              <input type="text" name="cognom2" matInput placeholder="Segon cognom" [(ngModel)]="preinscripcio.alumne.cognom2" [disabled]="!preinscripcio.alumne.isnew" i18n-placeholder>
          </mat-form-field>  
      </mat-grid-tile>    
      <mat-grid-tile></mat-grid-tile>                                                                    
      <mat-grid-tile>
          <mat-form-field class="pre-field">            
              <input matInput name="data-naixement" placeholder="Data de naixement" disabled [ngModel]="preinscripcio.alumne.dataNaixement" i18n-placeholder="@@71310302ab686b5ac15e8e78e25efffc9aed00db">
          </mat-form-field>                
      </mat-grid-tile>                            
      <mat-grid-tile>
          <mat-form-field class="pre-field">
              <input matInput name="pais-naixement" placeholder="País de naixement" [matAutocomplete]="paisNaixement" required
                  [formControl]="paisNaixementCtrl" [ngModel]="preinscripcio.alumne.paisNaixement" (ngModelChange)="paisNaixementChange($event)" i18n-placeholder>
              <mat-autocomplete #paisNaixement="matAutocomplete" [displayWith]="utilitats.displayName">
                  <mat-option *ngFor="let x of filteredPaisosNaixement | async" [value]="x">                                        
                      {{ x?.name }}
                  </mat-option>
              </mat-autocomplete>
          </mat-form-field>                            
      </mat-grid-tile>
      <mat-grid-tile *ngIf="preinscripcio.alumne.paisNaixementEspanya()">
          <mat-form-field class="pre-field">                            
              <input matInput name="poblacio-naixement" placeholder="Població de naixement" [matAutocomplete]="poblacioNaixement" required
                  [formControl]="poblacioNaixementCtrl" [ngModel]="preinscripcio.alumne.poblacioNaixement" (ngModelChange)="poblacioNaixementChange($event)" i18n-placeholder>
              <mat-autocomplete #poblacioNaixement="matAutocomplete" [displayWith]="utilitats.displayName">
                  <mat-option *ngFor="let x of filteredPoblacionsNaixement | async" [value]="x">                                        
                      {{ x?.name }}
                  </mat-option>
              </mat-autocomplete>
          </mat-form-field>                            
      </mat-grid-tile>
      <mat-grid-tile *ngIf="!preinscripcio.alumne.paisNaixementEspanya()">
        <mat-form-field class="pre-field">
            <input matInput name="poblacio-naixement-text" placeholder="Població de naixement" [(ngModel)]="preinscripcio.alumne.poblacioNaixementText" required i18n-placeholder>
        </mat-form-field>                            
      </mat-grid-tile>                            
      <mat-grid-tile>
          <mat-form-field class="pre-field">
              <input matInput name="nacionalitat" placeholder="Nacionalitat" [matAutocomplete]="nacionalitat" required
                  [formControl]="nacionalitatCtrl" [ngModel]="preinscripcio.alumne.nacionalitat" (ngModelChange)="nacionalitatChange($event)" i18n-placeholder>
              <mat-autocomplete #nacionalitat="matAutocomplete" [displayWith]="utilitats.displayName">
                  <mat-option *ngFor="let x of filteredNacionalitats | async" [value]="x">                                        
                      {{ x?.name }}
                  </mat-option>
              </mat-autocomplete>
          </mat-form-field>                            
      </mat-grid-tile>                    
    </mat-grid-list>
    <div align="left" style="margin: 15px">
        <p i18n="@@TitolDiscapacitat" style="font-weight: bold;">Discapacitat</p>    
        <mat-checkbox name="discapacitat" class="pre-controls" [(ngModel)]="preinscripcio.alumne.discapacitat" i18n="@@Discapacitat">Marqueu la casella si patiu algun tipus de discapacitat</mat-checkbox>        
        <br>
        <mat-hint i18n="@@DiscapacitatNota">La Universitat de Girona garanteix el tractament confidencial d'aquestes dades, d'acord amb la normativa vigent. Tingues present que pel fet de marcar aquesta casella autoritzes l'Àrea d’Inclusió de la Universitat a concertar amb tu una entrevista personal, a fi de determinar les teves necessitats específiques. Recorda també que, per poder beneficiar-te de les exempcions de preus en estudis oficials per a estudiants amb discapacitat, cal que acreditis que tens reconeguda legalment aquesta condició presentant el certificat o resolució corresponent.</mat-hint>
    </div>      
    <div align="left" style="margin: 15px">
        <p i18n="@@TitolInteroperabilitat" style="font-weight: bold;">Consulta de dades o documents en possessió d’altres administracions</p>
        <p i18n="@@Interoperabilitat1" >Tret que t’hi oposis, la Universitat de Girona consultarà telemàticament les dades o documents següents, que figuren en els registres d’altres administracions, en cas que siguin necessaris per als procediments relacionats amb el teu expedient acadèmic: número de la Seguretat Social (en cas de realització de pràctiques externes), títol de família nombrosa, títols universitaris oficials<br/>Pots oposar-t’hi marcant la casella següent, amb el benentès que en aquest cas hauràs d’aportar personalment la documentació requerida.</p>
        <mat-checkbox name="interoperabilitat" class="pre-controls" [(ngModel)]="preinscripcio.alumne.interoperabilitat" i18n="@@Interoperabilitat2">M’oposo a l’obtenció d’aquestes dades o documents per part de la Universitat de Girona i em comprometo a aportar-los personalment</mat-checkbox>
        <br>
        <mat-hint i18n="@@Interoperabilitat3">Nota. La no-oposició a la consulta de dades o documents no eximeix de la presentació de la documentació en els casos en què sigui imprescindible o la normativa així ho exigeixi</mat-hint>
    </div>
    <mat-grid-list cols="4" rows="3" rowHeight="80px">
        <mat-grid-tile colspan="4" *ngIf="preinscripcio.potModificar">
          <div class="pre-controls-right">
              <button mat-raised-button color="primary" (click)="continua()" [disabled]="!isValid()" i18n>Continua</button> 
          </div>
      </mat-grid-tile>
  </mat-grid-list>                        
</form>



// WEBPACK FOOTER //
// ./src/app/dades-personals/dades-personals.component.html